<template>
  <div>
    <v-snackbar v-model="showsnackbar" color="#9eaade" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout justify-center wrap v-if="notice.length>0">
      <v-flex xs6 sm4 md1 pl-md-3>
        <v-img width="30px" src="./../../assets/images/notice.svg"></v-img>
      </v-flex>
      <v-flex xs6 sm8 md9 text-left>
        <span style="font-family: nunitosansbold; font-size: 18px"
          >Noticeboard</span
        >
      </v-flex>
      <v-flex xs6 sm4 md2 text-right>
        <v-btn
          outlined
          small
          rounded
          to="/noticeboard2"
          style="text-transform: none; font-size: 10px"
          color="#747474"
          >View all
          <v-icon style="font-size: 14px" color="#D3D3D3"
            >mdi-arrow-right</v-icon
          ></v-btn
        >
      </v-flex>
      <v-flex xs12 v-for="(item, i) in notice" :key="i" pt-5>
        <v-layout justify-start wrap py-0>
          <v-flex xs12 sm12 md4 pr-sm-5 pt-2>
            <v-card
              elevation="2"
              color="#6CC9D9"
              hover
              dark
              max-height="500"
              max-width="350"
            >
              <v-img
                class="white--text align-center"
                height="200px"
                :src="mediaURL + item.image"
              >
                <v-flex xs12 sm12 md12 pt-4>
                  <v-card-text>
                    <v-icon>mdi-image-outline</v-icon>
                  </v-card-text>
                </v-flex>
                <v-flex xs12 sm12 md12 pb-6>
                  <v-card-text>
                    <span
                      style="font-family: nunitosansextrabold; font-size: 22px"
                      >{{ item.title }}</span
                    >
                  </v-card-text>
                </v-flex>
              </v-img>
            </v-card>
          </v-flex>
          <v-flex xs12 sm12 md7 py-2 py-md-0>
            <span
              style="
                font-family: nunitosanssemibold;
                font-size: 18px;
                color: #000000;
              "
              >{{ item.title }}</span
            ><br />
            <span style="color: #777676; font-family: nunitosansregular">
              {{ item.description }}</span
            >
            <!-- </v-flex> -->
            <v-flex xs12 pt-4>
              <span style="color: #717171; font-family: nunitosansregular">{{
                item.author
              }}</span>
            </v-flex>
            <v-layout justify-center wrap>
              <v-flex xs4 sm5 md4>
                <span
                  style="
                    color: #717171;
                    font-family: nunitosansregular;
                    font-size: 12px;
                  "
                  >{{ item.designation }}</span
                >
              </v-flex>
              <v-flex xs6 sm5 md4>
                <span
                  style="
                    color: #717171;
                    font-family: nunitosansregular;
                    font-size: 12px;
                  "
                  >{{ DateFormatted(item.noticeDate) }}</span
                >
              </v-flex>
              <v-flex xs2 sm2 md2 text-right>
                <router-link style="text-decoration:none" :to="'/noticeEdit?key=' + item._id">
                <v-icon>mdi-file-edit-outline</v-icon>
                </router-link>
              </v-flex>
              <v-flex xs2 text-right>
                <v-dialog v-model="item.delete" max-width="600px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="#645D5D" v-on="on" v-bind="attrs"
                      >mdi-delete-outline</v-icon
                    >
                  </template>
                  <v-card>
                    <v-card-title style="font-family: nunitosansregular">
                      Are you sure you want to delete this Notice?
                    </v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="item.delete = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="deleteItem(item)"
                        >OK</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      showsnackbar: false,
      timeout: 5000,
      notice: [],
      appLoading: false,
      msg: "",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    DateFormatted(params) {
      return params ? moment(params).format("DD-MM-Y ,hh:mm A") : "";
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/notice/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          var temp = [];
          temp = response.data.data;
          //  this.$emit("stepper", {
          //       myText: response.data,
          //     });
          if (temp.length > 2) {
            this.notice = temp.slice(0, 2);
          } else {
            this.notice = response.data.data;
          }
          // this.notice = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteItem(r) {
      var data = {};
      data["id"] = r._id;
      axios({
        url: "/notice/remove",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>